import React from 'react';
import { Card, Collapse, Timeline, Typography } from '@duxton-web/ui';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';

import Overlay from '../../components/overlay';
import { isEditMode } from '../../constants';
import { useExperimentContext } from '../../contexts/experiment-context';
import Duration from './duration';
import Population from './population';
import SampleSize from './sample-size';
import { REQUESTED } from '@/constants';

export const Estimate = () => {
  const params = useParams<{ action: string }>();
  const { action } = params;

  const experimentContext = useExperimentContext();
  const { experiment } = experimentContext;

  const showOverlay = isEditMode(action) && experiment?.state !== REQUESTED;

  return (
    <Card
      styles={{
        body: {
          padding: 0,
        },
      }}
    >
      <Overlay
        subTitle="Editing of estimate is not allowed in current state."
        showOverlay={showOverlay}
      />
      <Collapse
        expandIconPosition="end"
        defaultActiveKey={['population-duration-sample-size']}
        style={{ backgroundColor: 'white' }}
        bordered={false}
        items={[
          {
            key: 'population-duration-sample-size',
            label: (
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <Typography.Text strong>
                  Population, Duration and Sample Size
                </Typography.Text>
                <Typography.Metadata type="secondary">
                  Select the population, duration and sample size you want to
                  engage in this experiment.
                </Typography.Metadata>
              </div>
            ),
            children: (
              <Timeline
                style={{ padding: 16, marginBottom: '-16px' }}
                items={[
                  {
                    dot: <TimelineStepIndicator>1</TimelineStepIndicator>,
                    children: (
                      <div style={{ marginLeft: 8 }}>
                        <Population />
                      </div>
                    ),
                  },
                  {
                    dot: <TimelineStepIndicator>2</TimelineStepIndicator>,
                    children: (
                      <div style={{ marginLeft: 8 }}>
                        <Duration />
                      </div>
                    ),
                  },
                  {
                    dot: <TimelineStepIndicator>3</TimelineStepIndicator>,
                    children: (
                      <div style={{ marginLeft: 8 }}>
                        <SampleSize />
                      </div>
                    ),
                  },
                ]}
              />
            ),
          },
        ]}
      />
    </Card>
  );
};

export const TimelineStepIndicator = styled.div`
  align-items: center;
  background-color: #eef9f9;
  border-radius: 8px;
  color: #005339;
  display: flex;
  height: 40px;
  justify-content: center;
  line-height: 0px;
  margin-top: 16px;
  width: 40px;
`;

export default Estimate;
